import { q } from 'groqd'
import type { InferType } from 'groqd'

import { getSlugsQuery, imageAsset } from '@/cms/helperTypes'

export const blogPostsQuery = q('*')
  .filter(
    `
  _type == "blogPost" &&
  $lang in availableLanguages &&
  $market in availableMarkets &&
  enabledInProduction == true &&
  publicationType == "blogPost" &&
  (publishAfter < now() || !defined(publishAfter))
`
  )
  .grab({
    slug: ['slug[$lang].current', q.string()],
    locale: ['$lang + "-" + $market', q.string()],
  })

export const postQuery = q('*')
  .filter(
    `
  _type == "blogPost" &&
  $lang in availableLanguages &&
  $market in availableMarkets &&
  $slug == slug[$lang].current
  `
  )
  .grab({
    _id: q.string(),
    availableMarkets: q.array(q.string()),
    publicationType: q.string(),
    enabledInProduction: q.boolean().nullable(),
    metaDescription: q('metaDescription').grab({
      title: ['title[$lang]', q.string()],
      description: ['description[$lang]', q.string()],
    }),
    slug: ['slug[$lang].current', q.string()],
    slugs: ['slug', q.object(getSlugsQuery())],
    heading: ['heading[$lang]', q.string()],
    description: ['description[$lang]', q.string()],
    content: ['content[$lang]', q.array(q.unknown())],
    heroImage: q('heroImage').grab({
      alt: ['alt[$lang]', q.string().nullable()],
      image: q('localeHeroImage[$lang]').grab({
        _type: q.literal('image'),
        asset: q('asset').deref().grab(imageAsset),
      }),
    }),
    author: q('author')
      .deref()
      .grab({
        firstName: q.string(),
        lastName: q.string(),
        image: q('image').grab({
          _type: q.literal('image'),
          asset: q('asset').deref().grab(imageAsset).nullable(),
        }),
      })
      .nullable(),
    publishAfter: q.string().nullable(),
    publishDate: q.string().nullable(),
    readingTime: q.number().nullable(),
    categories: q('categories')
      .filter()
      .deref()
      .grab({
        title: ['title[$lang]', q.string()],
      })
      .nullable(),
  })
  .slice(0)

export type BlogPost = InferType<typeof postQuery>
